import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { _DeleteButton, _InputLabel, _SubLabel, _SubLabelWrapper } from "../inputStyles";
import { _SidebarStudentIcon } from "../../../../pages/StudentProfile/style"; // yes this is duplicated

var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
    icon = _ref.icon;
  if (!text || text.length <= 0) return null;
  var iconName = icon || 'info-circle';
  return /*#__PURE__*/React.createElement("span", {
    "data-tip": text
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: iconName
  }));
};
var SidebarTooltip = function SidebarTooltip(_ref2) {
  var text = _ref2.text,
    icon = _ref2.icon,
    status = _ref2.status;
  if (!text || text.length <= 0) return null;
  return /*#__PURE__*/React.createElement(_SidebarStudentIcon, {
    status: status
  }, /*#__PURE__*/React.createElement(Tooltip, {
    text: text,
    icon: icon
  }));
};
var ValidationTooltip = function ValidationTooltip(_ref3) {
  var status = _ref3.status;
  if (status === undefined) return null;
  if (status === null) {
    return /*#__PURE__*/React.createElement(SidebarTooltip, {
      icon: "exclamation-triangle",
      status: "warning",
      text: "Email Has Not Yet Been Validated"
    });
  }
  if (status.is_valid) {
    return /*#__PURE__*/React.createElement(SidebarTooltip, {
      status: "success",
      text: "Email is Valid",
      icon: "check"
    });
  }
  return /*#__PURE__*/React.createElement(SidebarTooltip, {
    status: "fail",
    text: "Email is Invalid",
    icon: "times-circle"
  });
};
var InputLabel = function InputLabel(_ref4) {
  var htmlFor = _ref4.htmlFor,
    children = _ref4.children,
    className = _ref4.className,
    deleteLabel = _ref4.deleteLabel,
    error = _ref4.error,
    index = _ref4.index,
    labelText = _ref4.labelText,
    required = _ref4.required,
    subLabel = _ref4.subLabel,
    tooltip = _ref4.tooltip,
    validationStatus = _ref4.validationStatus,
    tooltipComponent = _ref4.tooltipComponent;
  var computedClassName = [className, required ? 'required' : null, error ? 'error' : null].filter(function (n) {
    return !!n;
  }).join(' ');
  var text = typeof labelText === 'string' && labelText.trim() === '' ? "\xA0" : labelText;
  var handleDelete = useCallback(function () {
    return deleteLabel(index);
  }, [deleteLabel, index]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(_InputLabel, {
    htmlFor: htmlFor,
    className: computedClassName
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      marginBottom: '3px',
      display: 'inline-block'
    }
  }, text, tooltipComponent), children, /*#__PURE__*/React.createElement(Tooltip, {
    text: tooltip
  }), /*#__PURE__*/React.createElement(ValidationTooltip, {
    status: validationStatus
  })), subLabel && /*#__PURE__*/React.createElement(_SubLabelWrapper, null, subLabel && /*#__PURE__*/React.createElement(_SubLabel, null, subLabel), deleteLabel && /*#__PURE__*/React.createElement(_DeleteButton, {
    onClick: handleDelete
  }, "DELETE")));
};
InputLabel.propTypes = {
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  labelText: PropTypes.string,
  error: PropTypes.bool,
  required: PropTypes.bool
};
InputLabel.defaultProps = {
  className: undefined,
  error: false,
  required: false,
  labelText: null
};
export default InputLabel;